import { createBrowserRouter, Navigate } from 'react-router-dom';
import { TripsPage } from './pages/Trips';
import { TripNewPage } from './pages/TripNew';
import { TripDetailPage } from './pages/TripDetail';
import { PlansPage } from './pages/Plans';
import { PlanNewPage } from './pages/PlanNew';
import { PlanDetailPage } from './pages/PlanDetail';
import { PoisPage } from './pages/Pois';
import { LevelerPage } from './pages/Leveler';
import { SettingsPage } from './pages/Settings';
import { LevelerSettingsPage } from './pages/LevelerSettingsPage';
import { AppShell } from './components/AppShell';

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <Navigate to="/trips" replace /> },
      { path: '/trips', element: <TripsPage /> },
      { path: '/trips/new', element: <TripNewPage /> },
      { path: '/trips/:id', element: <TripDetailPage /> },
      { path: '/plans', element: <PlansPage /> },
      { path: '/plans/new', element: <PlanNewPage /> },
      { path: '/plans/:id', element: <PlanDetailPage /> },
      { path: '/pois', element: <PoisPage /> },
      // La livella si apre spesso da un'icona sulla home del telefono, quindi
      // l'URL è corto e in italiano: è un indirizzo che si legge, non solo un path.
      { path: '/livella', element: <LevelerPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/settings/livella', element: <LevelerSettingsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
